import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Suspense, useEffect } from "react";
import Loader from "components/common/loader";
import SignInWithClerk from "components/features/auth/sign-in/signInWithClerk";
import SignUpWithClerk from "components/features/auth/sign-up/signUpWithClerk";
import { useAuth, useUser } from "@clerk/clerk-react";
import Dashboard from "components/features/dashboard/dashboard";
import { ProtectedRoute } from "./protectedRoute";
import UserProvisioning from "components/features/auth/sign-in/userProvisioning";
import { mixpanelCustomEvent } from "mixpanel/eventTriggers";
import { MixpanelEventName } from "mixpanel/types";

interface AppRouterProps {}

// eslint-disable-next-line no-empty-pattern
export function AppRouter({}: AppRouterProps) {
  const { isSignedIn } = useAuth();
  const { user } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (isSignedIn && location.pathname === "/") {
      const mixpanelProps = {
        $name: `${user?.fullName}`,
        $email: user?.emailAddresses[0]?.emailAddress,
      };

      mixpanelCustomEvent({
        mixpanelProps,
        id: user?.id?.toString() || "",
        eventName: MixpanelEventName.userDirectlyLoggedinAccountsApp,
      });
      navigate("/dashboard");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn, navigate, location.pathname]);

  return (
    <>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<SignInWithClerk />} />
          <Route path="/sign-in" element={<SignInWithClerk />} />
          <Route path="/sign-in/*" element={<SignInWithClerk />} />
          <Route path="/sign-up/*" element={<SignUpWithClerk />} />

          <Route path="/sign-up" element={<SignUpWithClerk />} />
          <Route
            path="/user-provisioning"
            element={
              <ProtectedRoute>
                <UserProvisioning />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Suspense>
    </>
  );
}
